import { fg } from '@confluence/feature-gating';

const ONEDRIVE_PICKER = 'onedrive-picker';
const IFS_DIRECT_PATH_PROD = `https://cc-import-sources.services.atlassian.com/${ONEDRIVE_PICKER}`;
const IFS_DIRECT_PATH_FEDRAMP_SANDBOX = `https://cc-import-sources.atlassian-fex.com/${ONEDRIVE_PICKER}`;
const IFS_DIRECT_PATH_STAGING = `https://cc-import-sources.stg.services.atlassian.com/${ONEDRIVE_PICKER}`;
const IFS_DIRECT_PATH_LOCAL = `http://localhost:8080/${ONEDRIVE_PICKER}`;
const IFS_DIRECT_PATH_FEDRAMP_STG = `https://cc-import-sources.stg.services.atlassian-us-gov-mod.com/${ONEDRIVE_PICKER}`;
const IFS_DIRECT_PATH_FEDRAMP_PROD = `https://cc-import-sources.services.atlassian-us-gov-mod.com/${ONEDRIVE_PICKER}`;

const IFS_DIRECT_PATH_STAGING_BIFROST =
	'https://cc-import-sources-onedrive.stg-east.frontend.public.atl-paas.net';
const IFS_DIRECT_PATH_PROD_BIFROST =
	'https://cc-import-sources-onedrive.prod-east.frontend.public.atl-paas.net';

/**
 * Resolves the origin hosting the OneDrive picker document for the current environment.
 *
 * The picker runs in a cross-origin iframe because Microsoft's picker must be opened by a
 * real user click inside that document. Shared by the confirm modal and the inline
 * pointer overlay so both always point at the same environment.
 */
export const getIFSDirectPath = (environment: string | undefined): string => {
	const hostname = window?.location?.hostname || '';
	const environmentTail = hostname.split('.').slice(-2).join('.');
	const isLocal = hostname === 'localhost';
	const isProd = environment === 'PRODUCTION';

	switch (environmentTail) {
		case 'atlassian-fex.com':
		case 'atlassian-fex.net':
			return IFS_DIRECT_PATH_FEDRAMP_SANDBOX;

		case 'atlassian-us-gov-mod.com':
		case 'atlassian-us-gov-mod.net':
			return IFS_DIRECT_PATH_FEDRAMP_PROD;

		case 'atlassian-stg-fedm.net':
			return IFS_DIRECT_PATH_FEDRAMP_STG;

		default:
			if (isProd) {
				// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
				if (fg('cc_feature_discovery_ifs_fe')) {
					return IFS_DIRECT_PATH_PROD_BIFROST;
				}
				return IFS_DIRECT_PATH_PROD;
			} else if (isLocal) {
				// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
				if (fg('cc_feature_discovery_ifs_fe')) {
					return IFS_DIRECT_PATH_STAGING_BIFROST;
				}
				return IFS_DIRECT_PATH_LOCAL;
			} else {
				// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
				if (fg('cc_feature_discovery_ifs_fe')) {
					return IFS_DIRECT_PATH_STAGING_BIFROST;
				}
				return IFS_DIRECT_PATH_STAGING;
			}
	}
};
